import { render, staticRenderFns } from "./SCharacter.vue?vue&type=template&id=6f1bd8b4"
import script from "./SCharacter.vue?vue&type=script&lang=js"
export * from "./SCharacter.vue?vue&type=script&lang=js"
import style0 from "./SCharacter.vue?vue&type=style&index=0&id=6f1bd8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports